module.exports = __webpack_public_path__ + "img/drink_bubbletea.505a6d46.png";